(function($) {
    const swiper_houses = new Swiper('.swiper-houses', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.houses-right',
            prevEl: '.houses-left'
        }
    });

    // $(document).ready(() => {
    //     const house = $('.swiper-slide-active .house_number').text();
    //     $('.js_flat_contact').attr('data-houseid', house);
    //
    //     $('.js_flat_contact').click(() => {
    //         const house = $('.swiper-slide-active .house_number').text();
    //         $('.js_flat_contact').attr('data-houseid', house);
    //         $('#message').val(`${localize.selectedApartmentText} ${house}`);
    //     });
    // });
})(jQuery);

(function($) {
    const swiper_gallery = new Swiper('.swiper-gallery', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 2500
        },
        navigation: {
            nextEl: '.swiper-right2',
            prevEl: '.swiper-left2'
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });
})(jQuery);

(function($) {
    const swiper_opportunities = new Swiper('.swiper-opportunities', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 600,
        autoplay: {
            delay: 3200
        },
        pagination: {
            el: '.swiper-pagination2',
            clickable: true
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        parallax: true
    });
})(jQuery);
